const initialState = {
  hasFetched: false,
  data: {},
  fetchError: null,
  isFetching: false
};

export default function workflows (state = initialState, action) {
  const {
    data,
    fetchError,
    type
  } = action;


  if ('WORKFLOWS_FETCH_REQUEST' === type) {
    return { ...state, isFetching: true };
  }

  if ('WORKFLOWS_FETCH_SUCCESS' === type) {
    return { ...state, data, hasFetched: true, isFetching: false };
  }

  if ('WORKFLOWS_FETCH_FAILURE' === type) {
    return { ...state, fetchError, hasFetched: true, isFetching: false };
  }

  return state;
}
